import { Container } from "react-bootstrap";

function SolidCAM() {
  return (
    <Container style={{ padding: "1.5rem" }}>
      <h1>SolidCAM</h1>
      <br />

      <p>
        CAD und CAM sind in der Praxis eng miteinander verzahnt. Neben
        langjähriger Erfahrung im CAD-Umfeld vermittle ich auch fundiertes
        Wissen im Bereich CAM.
      </p>

      <p>
        Ich betreue Schulungen in SolidCAM – von den Grundlagen bis zur
        Vertiefung – mit Schwerpunkt auf 2½- bis 5-Achs-Bearbeitung in
        Verbindung mit SolidWorks.
      </p>

      <p>
        Die Inhalte werden praxisnah auf typische Fertigungsprozesse und die
        Anforderungen der jeweiligen Teilnehmer abgestimmt.
      </p>

      <div className="spacer"></div>
    </Container>
  );
}

export default SolidCAM;
